import React, { useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { connect } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ResetForgetPasswordPayloadType } from '../../commonTypes/authTypes';
import { BeforeAuthHeader, ErrorSuccessModal, Loader } from '../../components/commons';
import { ResetForgetPasswordCard } from '../../components/ResetForgetPassword';
import { resetAuthError, resetAuthSuccess, resetForgetPasswordAction, resetResetPasswordToken } from '../../redux/auth';
import { RootState } from '../../redux/rootReducers';

type PasswordType = {
  newPassword: string;
  confirmNewPassword: string;
}

type AppProps = {
  history: any;
  success: number | null;
  fetching: boolean;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  dispatchResetForgetPasswordAction: (data: ResetForgetPasswordPayloadType) => void
  dispatchResetAuthError: () => void;
  dispatchResetPasswordToken: () => void;
  dispatchResetAuthSuccess: () => void;
}

const ResetForgetPassword = ({
  history,
  success,
  statusCode,
  fetching,
  error,
  message,
  dispatchResetForgetPasswordAction,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetPasswordToken
}: AppProps) => {
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [submit, setSubmit] = useState(false);
  const { search } = useLocation();
  let token = search?.split('=')[1]

  const handleSubmitResetPassword = (data: any) => {
    if (token) {
      let finalData = {
        token,
        ...data
      }
      dispatchResetForgetPasswordAction(finalData)
      setSuccessMessage("Password changed successfully!")
      setSubmit(true)
    }
  }

  const redirectToForgetPassword = () => {
    history.push({
      pathname: "/login",
      state: 'true'
    });
  };

  const handleErrorSuccessModal = () => {
    if (error && statusCode !== 401) {
      return <ErrorSuccessModal
        type="error"
        isOpen={!!error}
        title="Error"
        message={"Sorry Link Expired!"}
        buttonText="Try Again"
        onPress={() => redirectToForgetPassword()}
        statusCode={statusCode}

      />
    }
    else if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={successMessage}
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthSuccess()
            dispatchResetPasswordToken();
            history.push('/login');
          }}
          statusCode={statusCode}
        />
      )
    }
    return false;
  }

  return (
    <>
      <ResetForgetPasswordCard
        handleSubmitResetPassword={handleSubmitResetPassword}
      />
      {fetching && <Loader />}
      {handleErrorSuccessModal()}
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  success: state.auth.success,
  statusCode: state.auth.statusCode,
  error: state.auth.error,
  fetching: state.auth.fetching,
  message: state.auth.message
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetForgetPasswordAction: (data: ResetForgetPasswordPayloadType) =>
    dispatch(resetForgetPasswordAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetPasswordToken: () => dispatch(resetResetPasswordToken()),

})

export default connect(mapStateToProps, mapDispatchToProps)(ResetForgetPassword);